module.exports = __webpack_public_path__ + "static/media/icon-plug-blue.95fc8069.svg";